import React from 'react';
import { useTranslation } from 'react-i18next'; 
import UsedEquipmentsimg from '../../../assets/images/usedequpmentsmenu.png';



function UsedEquipments() {
  const { t } = useTranslation(); 

  const products = [
    {
      name: t("Used Equipments"),
      description: t(
        "high-quality used equipment for the wine industry, including crushers, destemmers, presses, pumps, and tanks. Reliable and cost-effective solutions for wineries of all sizes, ideal for production, fermentation, and bottling processes. Carefully inspected and ready to use."
      ),
      img: UsedEquipmentsimg,
    },
    
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.img} alt={product.name} /> 
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default UsedEquipments;
